import { MenuProps } from 'antd';
import {
  SettingsIcon,
  OrderIcon,
  ProductsIcon,
  UserIcon,
  StoreIcon,
  AnalyzeIcon,
  CompanyIcon,
} from '../../Icons';
import { MenuItemLabel } from './MenuItemLabel';
import { RouteNames } from '../../../types';

interface IGetMenuItemsOption {
  isMenuCollapsed: boolean;
}

export const getMenuItems = ({ isMenuCollapsed = false }: IGetMenuItemsOption) => {
  const items: MenuProps['items'] = [
    {
      key: RouteNames.AdminSettings,
      label: (
        <MenuItemLabel
          icon={<SettingsIcon size={20} />}
          title={isMenuCollapsed ? '' : 'Settings'}
        />
      ),

      children: [
        {
          key: RouteNames.AdminSettingsCompany,
          label: (
            <MenuItemLabel
              to={RouteNames.AdminSettingsCompany}
              icon={<CompanyIcon size={20} />}
              title={isMenuCollapsed ? '' : 'Company'}
            />
          ),
        },
        {
          key: RouteNames.AdminSettingsProducts,
          label: (
            <MenuItemLabel
              to={RouteNames.AdminSettingsProducts}
              icon={<ProductsIcon size={20} />}
              title={isMenuCollapsed ? '' : 'Products'}
            />
          ),
        },
        {
          key: RouteNames.AdminSettingsStores,
          label: (
            <MenuItemLabel
              icon={<StoreIcon size={20} />}
              title={isMenuCollapsed ? '' : 'Stores'}
              to={RouteNames.AdminSettingsStores}
            />
          ),
        },
        {
          key: RouteNames.AdminSettingsUsers,
          label: (
            <MenuItemLabel
              icon={<UserIcon size={20} />}
              title={isMenuCollapsed ? '' : 'Users'}
              to={RouteNames.AdminSettingsUsers}
            />
          ),
        },
      ],
    },
    // {
    //   key: RouteNames.AdminAnalyze,
    //   label: (
    //     <MenuItemLabel icon={<AnalyzeIcon size={20} />} title={isMenuCollapsed ? '' : 'Analyze'} />
    //   ),

    //   children: [
    //     {
    //       key: RouteNames.AdminAnalyzeOrders,
    //       label: (
    //         <MenuItemLabel
    //           icon={<OrderIcon size={20} />}
    //           title={isMenuCollapsed ? '' : 'Orders'}
    //           to={RouteNames.AdminAnalyzeOrders}
    //         />
    //       ),
    //     },
    //     {
    //       key: RouteNames.AdminAnalyzeProducts,

    //       label: (
    //         <MenuItemLabel
    //           to={RouteNames.AdminAnalyzeProducts}
    //           icon={<ProductsIcon size={20} />}
    //           title={isMenuCollapsed ? '' : 'Products'}
    //         />
    //       ),
    //     },
    //     {
    //       key: RouteNames.AdminAnalyzeStores,
    //       label: (
    //         <MenuItemLabel
    //           icon={<StoreIcon size={20} />}
    //           title={isMenuCollapsed ? '' : 'Stores'}
    //           to={RouteNames.AdminAnalyzeStores}
    //         />
    //       ),
    //     },
    //     {
    //       key: RouteNames.AdminAnalyzeUsers,
    //       label: (
    //         <MenuItemLabel
    //           icon={<UserIcon size={20} />}
    //           title={isMenuCollapsed ? '' : 'Users'}
    //           to={RouteNames.AdminAnalyzeUsers}
    //         />
    //       ),
    //     },
    //   ],
    // },
  ];

  return items;
};
